import * as React from 'react';
import { Trans } from 'react-i18next';

export const CertificateDescription = () => {
  return (
    <div className={'certificate-search__description'}>
      <Trans
        i18nKey="certificates.description.html"
        components={{
          p: <p />,
          ul: <ul />,
          li: <li />,
        }}
      />
    </div>
  );
};
